import {z} from 'zod';
import {PromptToCardAgentStatus} from '../promptToCardAgent/promptToCardAgent';

export const responseSchema = z.object({
  status: z
    .enum([PromptToCardAgentStatus.AddOrUpdate, PromptToCardAgentStatus.NoAction])
    .describe(
      'The status of the agent, in case of failure, return noAction, otherwise return addOrUpdate',
    ),
  chainOfThoughts: z.string().describe('The chain of thoughts of the agent'),
});
